import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "../components/Logo";

const Section = ({ title, children }) => (
  <div className="mt-6">
    <h2 className="text-base font-bold text-[#0A1128]">{title}</h2>
    <div className="mt-1.5 space-y-2 text-sm leading-relaxed text-[#4A5568]">{children}</div>
  </div>
);

export default function TippgeberVereinbarung() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#F8F9FA]" data-testid="tippgeber-vereinbarung-page">
      <div className="flex items-center justify-between px-6 pb-2 pt-[calc(env(safe-area-inset-top)+1.5rem)]">
        <button data-testid="back-btn" onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-full text-[#0A1128] transition-colors hover:bg-black/5">
          <ArrowLeft size={22} />
        </button>
        <Logo />
        <div className="w-10" />
      </div>

      <div className="px-7 pb-16 pt-6">
        <div className="mb-1 h-px w-12 bg-[#C5A059]" />
        <h1 className="font-display text-4xl font-light tracking-tight text-[#0A1128]">Tippgeber-Vereinbarung</h1>

        <div className="mt-4 rounded-xl border border-[#C5A059]/30 bg-[#FBF8F1] p-3 text-xs leading-relaxed text-[#8a6d2f]" data-testid="tippgeber-placeholder-hint">
          Hinweis: Dies ist eine sorgfältig erstellte Vorlage und ersetzt keine Rechtsberatung. Bitte vor dem Einsatz durch eine Rechts-/Compliance-Beratung final prüfen lassen.
        </div>

        <Section title="1. Gegenstand">
          <p>Diese Vereinbarung regelt die Zahlung einer freiwilligen Tippgeber-Prämie für die Weitergabe eines Kontakts (eines „Tipps") an den Berater. Der Tippgeber gibt ausschließlich einen unverbindlichen Hinweis auf eine mögliche interessierte Person weiter.</p>
        </Section>

        <Section title="2. Keine Beratung, keine Vermittlung">
          <p>Der Tippgeber berät nicht, vermittelt keine Produkte, gibt keine Produktempfehlung ab und nimmt keine Tätigkeiten vor, die eine Erlaubnis nach § 34d GewO erfordern würden. Er stellt lediglich den Kontakt her. Die Beratung und Vermittlung erfolgt ausschließlich durch den erlaubten Berater.</p>
        </Section>

        <Section title="3. Zustimmung der empfohlenen Person (DSGVO)">
          <p>Die Kontaktdaten der empfohlenen Person werden erst nach deren ausdrücklicher Einwilligung verarbeitet und an den Berater weitergegeben. Ohne Bestätigung erfolgt keine Kontaktaufnahme.</p>
        </Section>

        <Section title="4. Prämie & Auszahlung">
          <p>Die Höhe der Prämie legt der Berater fest und ist im Kundenportal ersichtlich. Ein Anspruch entsteht nach den dort genannten Bedingungen (z. B. erfolgreiche Vermittlung). Die Auszahlung erfolgt per Überweisung auf das vom Tippgeber angegebene Konto, sobald der Auszahlungsbetrag den Mindestbetrag erreicht.</p>
        </Section>

        <Section title="5. Hinweis für Versicherungs-/Finanzempfehlungen">
          <p>Prämien werden nur für Tipps auf Dritte gezahlt. Für Empfehlungen im Versicherungsbereich gilt: Es dürfen keine Sondervergütungen an den Versicherungsnehmer des empfohlenen Vertrags im Sinne des § 48b VAG geleistet werden. Der Tippgeber bestätigt, dass er selbst nicht Versicherungsnehmer des empfohlenen Vertrags ist.</p>
        </Section>

        <Section title="6. Steuerlicher Hinweis">
          <p>Die Tippgeber-Prämie ist eine steuerpflichtige Einnahme des Tippgebers. Für die ordnungsgemäße Versteuerung ist der Tippgeber selbst verantwortlich. Bei regelmäßiger bzw. gewerblicher Tätigkeit können weitere Pflichten bestehen.</p>
        </Section>

        <Section title="7. Widerruf & Datenlöschung">
          <p>Eine erteilte Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden. Details regelt die Datenschutzerklärung.</p>
        </Section>
      </div>
    </div>
  );
}
